import React, { Component } from "react";
import { Dropdown } from "semantic-ui-react";
import { Link } from "react-router-dom";
import "./styles.css";
const { Menu, Item } = Dropdown;

class ArraysMovil extends Component {
  render() {
    const { setIndex, categories, handleHideClick } = this.props;
    const set = () => {
      setIndex(false);
      handleHideClick();
    };
    return (
      <Menu>
        <Item as={Link} to={`/products/Todos`} onClick={() => set()}>
          <strong className="item-all-sidebar">Todos los arreglos</strong>
        </Item>
        {categories.map(category => (
          <Item
            key={category.id}
            as={Link}
            to={`/products/${category.id}`}
            onClick={() => set()}
            className="itemAcordeon"
          >
            <strong className="item-category-sidebar">
              {category.data.name}
            </strong>
          </Item>
        ))}
      </Menu>
    );
  }
}
export default ArraysMovil;
